import ApiService from "../../util/ApiService";
import {
  GET_AUTOSUGGESTION_RESULTS,
  GET_AUTOSUGGESTION_RESULTS_SUCCESS,
  GET_AUTOSUGGESTION_RESULTS_ERROR,
  CLEAR_AUTOSUGGESTION_RESULTS,
  GET_TOOLBARCONFIG_REQUEST_ERROR,
  GET_TOOLBARCONFIG_REQUEST_SUCCESS,
  GET_TOOLBARCONFIG_REQUEST,
} from "./action-types";

export async function fetchToolBarConfig(dispatch) {
  dispatch({ type: GET_TOOLBARCONFIG_REQUEST });
  try {
    const url = "/api/search/v3/toolbar";
    const { data } = await ApiService.get(url);
    dispatch({
      type: GET_TOOLBARCONFIG_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: GET_TOOLBARCONFIG_REQUEST_ERROR, error: error.message });
  }
}

export async function fetchSuggestionResults(dispatch, query) {
  dispatch({ type: GET_AUTOSUGGESTION_RESULTS, payload: query });
  try {
    const url = "/api/search/v1/search/suggestions";
    const params = {
      query: query,
      maxItemsPerType: 5,
    };
    const completionResults = await ApiService.get(url, { params });
    dispatch({
      type: GET_AUTOSUGGESTION_RESULTS_SUCCESS,
      payload: completionResults.data,
    });
  } catch (error) {
    dispatch({ type: GET_AUTOSUGGESTION_RESULTS_ERROR, error: error.message });
  }
}

export async function clearSuggestionResults(dispatch) {
  dispatch({ type: CLEAR_AUTOSUGGESTION_RESULTS });
}
